import { render, staticRenderFns } from "./RiskImpact.vue?vue&type=template&id=13f1e82e&scoped=true&"
import script from "./RiskImpact.vue?vue&type=script&lang=js&"
export * from "./RiskImpact.vue?vue&type=script&lang=js&"
import style0 from "./RiskImpact.vue?vue&type=style&index=0&id=13f1e82e&lang=scss&scoped=true&"
import style1 from "./RiskImpact.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f1e82e",
  null
  
)

export default component.exports